export default "__VITE_ASSET__vAgDW1FH__"